import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import vSelect from 'vue-select'
import FullpageModal from 'vue-fullpage-modal'
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'

import { Plugins } from '@capacitor/core'

import { Filesystem, Directory, Encoding } from '@capacitor/filesystem'

import { Clipboard } from '@capacitor/clipboard'

import { Share } from '@capacitor/share'

import { Camera, CameraResultType } from '@capacitor/camera'

import {SecureStorage} from '@aparajita/capacitor-secure-storage'

// Vue Inner Image Zoom
import 'vue-inner-image-zoom/lib/vue-inner-image-zoom.css';

import '@capacitor/keyboard'

//Vuelidate
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

import CircularCountDownTimer from 'vue-circular-count-down-timer'
Vue.use(CircularCountDownTimer)

// Component Message Alert
import MessageBox from './components/message-box.vue'
Vue.component('message-box', MessageBox)

// Component Cupon Puntos
import BtnCuponPuntos from './components/puntos/btn-cupon.vue'
Vue.component('btn-cupon-puntos', BtnCuponPuntos);

// LOADINGS
import SmallLoading from './components/loading/small.vue'
Vue.component('loading-small', SmallLoading);

// VueSweetalert2
import VueSweetalert2 from 'vue-sweetalert2';
// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2);

await SecureStorage.setSynchronize(false)
await SecureStorage.setKeyPrefix("vsc-storage_")

// Una instancia de axios especial para peticiones al proyecto api
Vue.prototype.$axiosApi = axios.create()
//Otra instancia para agentes
Vue.prototype.$axiosAgentes = axios.create()

axios.defaults.baseURL = process.env.VUE_APP_URL
axios.defaults.withCredentials = true
axios.interceptors.request.use(config => {
    config.params = {...(config.params || {}), ver: __APP_VERSION__}
    return config
}, error => {
    return Promise.reject(error)
})
axios.interceptors.response.use(response => {
    return response
}, async (error) => {
    if (store.getters.isLoggedIn && error.response.status === 401) {
        await store.dispatch('logoutActions')
        await router.push({path: '/'})
    }
    return Promise.reject(error)
})

Vue.component('v-select', vSelect)
import 'vue-select/dist/vue-select.css'

moment.relativeTimeRounding(Math.floor)
moment.relativeTimeThreshold('s', 60)
moment.relativeTimeThreshold('m', 60)
moment.relativeTimeThreshold('h', 24)

// Para formato de fecha
Vue.filter('to_date_format', function (fecha, format = 'DD-MM-YYYY') {
    if (fecha) {
        return moment(fecha).locale("es-MX").format(format)
    }
    else {
        return ''
    }
})

// Para formato de fecha
Vue.filter('to_date_format_end', function (fecha, hours = 24) {
    if (!fecha) return '';
    const date = new Date(fecha);
    date.setHours(date.getHours() + hours);
    const now = moment();
    const future = moment(date);
    const diffHours = future.diff(now, 'hours'); // Calcula la diferencia en horas

    if (diffHours <= 0) {
        return 'menos de una hora';
    } else if (diffHours === 1) {
        return '1 hora';
    } else {
        return `${diffHours} horas`;
    }
});

// Para formato de fecha con hora
Vue.filter('to_datetime_format', function (fecha, format = 'DD-MM-YYYY') {
    if (fecha) {
        return moment(fecha).locale("es").format(format) + ' ' + moment(fecha).locale("es").format('LTS');
    }
    else {
        return ''
    }
})

// Fecha de publicación Koinonía10
Vue.filter('to_k10_datetime_format', function (fecha) {
    if (fecha) {
        const mFecha = moment(fecha).locale("es")
        const now = moment()
        if (now.diff(mFecha, 'days') < 7) {
            return mFecha.fromNow()
        } else {
            const format = 'D MMM' + (mFecha.year() !== now.year() ? ' YYYY' : '')
            return mFecha.format(format)
        }
    }
    else {
        return ''
    }
})

// Formato de fecha con nombre de mes
Vue.filter('to_pretty_date', function (fecha) {
    const options = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    }
    return new Date(fecha).toLocaleDateString('es-MX',options)
})

// Para formato de moneda
const currencyFormat = Intl.NumberFormat("es-MX", {style: 'currency', currency: 'MXN'})
Vue.filter('to_currency', (valor) => {
    return currencyFormat.format(valor)
});

// Para formato de moneda
Vue.filter('to_currency_digits', function (valor, digits) {
    // Limitar a 6 decimales
    var numeroFormateado = valor.toFixed(digits);

    // Agregar ceros a la izquierda si es necesario
    var partes = numeroFormateado.split('.');
    partes[0] = partes[0].padStart(2, '0');

    // Unir las partes formateadas
    return `$${partes.join('.')}`;
});

// Para delimeter
const delimiterFormat = Intl.NumberFormat(
  "es-MX",{minimumFractionDigits: 2, maximumFractionDigits: 2}
)
Vue.filter('to_delimeter', (valor) => {
    return delimiterFormat.format(valor);
});

const saldoFormat = Intl.NumberFormat(
  "es-MX", {minimumFractionDigits: 2, maximumFractionDigits: 6}
)
Vue.filter('toSaldo', (valor) => {
    return saldoFormat.format(valor)
})

const sixDecimalsFormat = Intl.NumberFormat(
  "es-MX", {minimumFractionDigits: 6, maximumFractionDigits: 6}
)
Vue.filter('to6Decimals', (valor) => {
    return sixDecimalsFormat.format(valor)
})

const millaresFormat = Intl.NumberFormat("es-MX")
Vue.filter('separar_millares', function (valor) {
    return millaresFormat.format(valor)
});

const compactFormat = Intl.NumberFormat("es-MX", {notation: "compact"})
Vue.filter('compactNumber', function (valor) {
    return compactFormat.format(valor).replace(/\s/g,'')
});

// Para Titleize Mayuscula en cada palabra
Vue.filter('to_titleize', function (string) {
    const palabras = string.split(' ')
    let new_string = ""
    palabras.forEach((palabra) => {
        new_string = new_string.concat(' ', palabra[0].toUpperCase() + palabra.substr(1).toLowerCase());
    })
    return new_string
});

Vue.filter('round', function (valor) {
    return Number.parseFloat(valor).toFixed(2);
})
// se usa en yatvii para recortar la descripcion de los negocios
Vue.filter('truncate', function (text, length, clamp) {
    clamp = clamp || '...';
    const node = document.createElement('div');
    node.innerHTML = text;
    const content = node.textContent;
    return content.length > length ? content.slice(0, length) + clamp : content;
})

Vue.use(FullpageModal)
Vue.use(VueAxios, axios)

Vue.config.productionTip = false
Vue.config.ignoredElements = ['cookie-consent-banner']

store.dispatch('tryAutoLogin').then(() => {
    new Vue({
        router,
        store,
        render: h => h(App),
        mounted: function() {
            Metro.init()
        }
    }).$mount('#app')
})

Vue.mixin({
    data: () => {
        return {
            keyCount: (Math.random().toString(36)+'00000000000000000').slice(2, 20),
            activity: {},
            cargando_page: false,
            user: {},
            connection: null,
        }
    },
    mounted: function () {
        this.user = this.$store.state.user;
    },
    computed: {
        yidi_puntos: function (){
            return this.$store.getters.yidiPuntos
        },
        saldo_publicitario: function (){
            return this.$store.getters.saldoPublicitario
        },
        saldo_alianza: function (){
            return this.$store.getters.saldoAlianza
        },
        saldo_bono_especial: function (){
            return this.$store.getters.bonoEspecial
        },
        saldo_tabla_dispersadora: function (){
            return this.$store.getters.tablaDispersadora
        },
        patrocinioDisponible: function (){
            return this.$store.getters.patrocinio
        },
        user_computed() {
            //Se debe verificar que this.$store exista porque al parecer el mixin se usa en componentes fuera de nuestro
            // control (vue-inner-image-zoom)
            return this.$store ? this.$store.getters.user : null
        },
        compra_publica_gemas: function (){
            return this.$store.state.compra_publica_gemas
        }
    },
    watch: {
        user_computed(newValue) {
            this.user = newValue
        },
    },
    methods: {
        randomColor: function (){
            let array_color = ['green','orange','teal','brown', 'ligthBlue']
            return array_color[(Math.random() * array_color.length) | 0]
        },
        uploadPhoto: async function (resultType = CameraResultType.DataUrl){
            return await Camera.getPhoto({
                quality: 90,
                allowEditing: false,
                promptLabelHeader: 'Seleccionar una imagen',
                promptLabelPhoto: 'Seleccionar una foto de la galería',
                promptLabelPicture: 'Tomar una nueva foto',
                promptLabelCancel: 'Cancelar',
                resultType: resultType
            });
        },
        share_info: async function (data){
            let title = data.title;
            let text = data.text;
            let dialogTitle = data.dialogTitle;

            console.log(data)
            await Share.share({
                title: title,
                text: text,
                dialogTitle: dialogTitle,
            });
        },
        copyTEXT: async function(text) {
            await Clipboard.write({
                string: text,
            });
            Metro.toast.create("Texto Copiado", null, null, "success");
        },
        openActivity: (type = 'simple', style = 'dark') => {
            return Metro.activity.open({
                type: type,
            });
        },
        closeActivity: (activity) => {
            Metro.dialog.close(activity);
            // this.cargando_page = false;
        },
        displayElement: function (element_id, activity_id) {
            let element = document.getElementById(element_id)
            let activity = document.getElementById(activity_id)
            if (element) {
                element.style.display = element.style.display === 'block' ? 'none' : 'block';
            }
            if (activity) {
                activity.style.display = activity.style.display === 'block' ? 'none' : 'block';
            }
        },
        dowloadFile: async (url, fileName, type, ib, share = false) => {
            return new Promise(async (resolve, reject) => {
                try {
                    const file_request = await fetch(url, {
                        method: 'GET',
                        credentials: 'include',
                        mode: 'no-cors',
                    });
                    console.log(file_request)

                    const file_blob = await file_request.blob();

                    const reader = new FileReader()
                    reader.readAsDataURL(file_blob)
                    reader.onloadend = async () => {
                        console.log(reader.result)
                        const file = await Filesystem.writeFile({
                            path: fileName,
                            data: reader.result,
                            directory: Directory.Documents,
                            recursive: true,
                        })

                        let fileResult = await Filesystem.getUri({
                            directory: Directory.Documents,
                            path: fileName
                        })

                        Metro.toast.create(`Descarga Exitosa, Busca en  tu seccion de Documentos el archivo "${fileName}"`, null, 5000, "success")
                        Metro.infobox.close(ib)

                        if (share){
                            await Share.share({
                                title: "Cotización de Productos",
                                text: "Comparto la lista de productos, para corroborar existencia y peso volumétrico aproximado .",
                                url: fileResult.uri,
                            }).then(() => console.log('Successful share'))
                                .catch((error) => console.log('Error sharing ::: ', error));
                        }

                       resolve(true)
                    }
                } catch(err) {
                    Metro.infobox.close(ib)
                    Metro.toast.create(`Descarga Fallida"`, null, 3000, "alert")
                    reject(err)
                }
            });
        },
        download_file: async (url, fileName, type, ib) => {

        },
        roundTo6: function (number) {
            return Math.round(number * 1e6) / 1e6
        },
    }
})